import { Module } from 'vuex';

import { ShiftCMSState } from '@/store';
import { LearningItem } from '@/models/learning-item.model';
import learningItemService from '@/services/learning-item.service';

export interface LearningState {
  items: LearningItem[];
}

export enum LearningMutations {
  SetLearningItems = 'les/SetLearningItems',
}

export enum LearningActions {
  GetLearningItem = 'les/GetLearningItem',
  GetLearningItems = 'les/GetLearningItems',
  AddLearningItem = 'les/AddLearningItem',
  UpdateLearningItem = 'les/UpdateLearningItem',
  UpdateLearningOrderItems = 'les/UpdateLearningOrderItems',
  DeleteLearningItem = 'les/DeleteLearningItem',
  PublishLearningItem = 'les/PublishLearningItem',
}

const sn = (str: LearningActions | LearningMutations): string =>
  str.replace(/les\//g, '');

export const learningStore: Module<LearningState, ShiftCMSState> = {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    [sn(LearningMutations.SetLearningItems)](state, items: LearningItem[]) {
      state.items = items;
    },
  },
  actions: {
    async [sn(LearningActions.GetLearningItem)](_, id) {
      const res = await learningItemService.get(id);
      if (res.status) {
        return res.data;
      }
    },
    async [sn(LearningActions.GetLearningItems)]({ commit }) {
      const res = await learningItemService.getList();
      if (res.status) {
        commit(sn(LearningMutations.SetLearningItems), res.data);
      }
    },
    async [sn(LearningActions.AddLearningItem)](
      { dispatch },
      item: LearningItem,
    ) {
      const res = await learningItemService.create(item);
      if (res.status) {
        dispatch(sn(LearningActions.GetLearningItems));
      }

      return res.status;
    },
    async [sn(LearningActions.UpdateLearningItem)](
      { dispatch },
      item: LearningItem,
    ) {
      const res = await learningItemService.update(item);
      if (res.status) {
        dispatch(sn(LearningActions.GetLearningItems));
      }
      return res.status;
    },
    async [sn(LearningActions.PublishLearningItem)](
      { dispatch },
      item: LearningItem,
    ) {
      const res = await learningItemService.publish(item.id, item.published);
      if (res.status) {
        dispatch(sn(LearningActions.GetLearningItems));
      }
      return res.status;
    },
    async [sn(LearningActions.DeleteLearningItem)]({ dispatch }, id: number) {
      const res = await learningItemService.delete(id);

      if (res.status) {
        dispatch(sn(LearningActions.GetLearningItems));
      }
    },
  },
};
